import PKG_TYPES from '../../constants/package_types';

export class AlertDetailsController {
	constructor($scope, $state, $stateParams, $timeout, AlertsDao, EventXDao, ImpactDao, ComponentsDao,
	            JFrogGridFactory, TOOLTIPS, WatchersDao, XRayUtils, IgnoreModal, IgnoreDao, User) {
		this.$state = $state;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$stateParams = $stateParams;
		this.alertsDao = AlertsDao;
		this.jfrogGridFactory = JFrogGridFactory;
		this.eventxDao = EventXDao;
		this.impactDao = ImpactDao;
		this.watchersDao = WatchersDao;
		this.componentsDao = ComponentsDao;
		this.utils = XRayUtils;
		this.IgnoreModal = IgnoreModal;
		this.IgnoreDao = IgnoreDao;
		this.user = User.getCurrent();


		this.TOOLTIP = TOOLTIPS.alerts;

		this.getAlertData();

		this._createGrid();

		this.severityLevels = {
			Critical: 3,
			Major: 2,
			Minor: 1,
			Unknown: 0
		}

		$(window).resize(() => {
			this.fix_size();
		});
	}

	fix_size() {
		$('.nav-tabs').css('width', $('.content-with-footer').width() + 'px');
	}

	_createGrid() {
		this.gridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
		                       .setRowTemplate('default')
		                       .setColumns(this._getColumns())
	}

	getAlertData() {
		this.impactedFilesTransformed = false;
		this.impactedFilesOrig = null;

		this.alertsDao.getSingle({}, {alertID: this.$stateParams.alertID}).$promise.then((alert) => {

			this.alertData = alert;
			this.title = 'Alert Details for Watch \'' + this.alertData.watch_name + '\'';
			this.alertData.target = this.alertData.target_type ? (this.alertData.target_type !== 'artifact' ? this.alertData.art_id + '::' + this.alertData.target_type + '::' + this.alertData.target_name : 'Every Artifact') : 'N/A';
			this.alertData.displayEventType = _.capitalize(this.alertData.event_type || 'other');

			if (this.alertData.method === 'impactAnalysis') {
				this.getEventXData();
			}
			else {
				this.issues = this.getScanIssues();
				this.updateIssueTabs();
			}


            this.affected_component = alert.impacted_files[0].component_id;

		});
	}

	getEventXData(issueID) {

		this.eventxDao.getIssueDetailsForAlert({
			id: issueID || this.alertData.source_id,
			type: this.alertData.impact_issue_type || 'vulnerability'
		}, {}).$promise.then((eventXData) => {


			if (!issueID) {
				this.issues = [eventXData];
				this.updateIssueTabs();
			}

            this.alertData.properties = {};

			/*
			 this.alertData.source_artifact = eventXData.components[0].component_id.substr(eventXData.components[0].component_id.lastIndexOf('/')+1);

			 this.alertData.source_compId = eventXData.components[0].component_id;
			 */

			this.alertData.properties.summary = eventXData.summary;
			this.alertData.properties.description = eventXData.description;
			this.alertData.properties.cves = eventXData.cves;

			let components_ids = [];

			if (eventXData.components) {
				if (eventXData.components.length > 0) {

					eventXData.components.forEach((comp) => {
						components_ids.push(comp.id);
					});

				}
			}

			this.alertData.properties.provider = eventXData.provider;

            if (this.alertData.properties.provider && this.alertData.properties.provider.toLowerCase().indexOf(
                    'snyk') > -1) {

                if (eventXData.sources && eventXData.sources.length) {
					this.snykUrl = eventXData.sources[0].url;
				}
			}

			if (eventXData.url) {
				this.alertData.properties.more_details = eventXData.url;
			}

			this.alertData.properties.issue_type = _.capitalize(eventXData.type || 'other');

			this.alertData.properties.severity = eventXData.severity;
			this.alertData.properties[components_ids.length > 1 ? 'component_ids' : 'component_id'] = this.utils.semverSort(
				components_ids);

			this.alertData.properties.created_at = eventXData.created;


			for (let key in eventXData.properties) {
				if (!this.alertData.properties[key]) {
					this.alertData.properties[key] = eventXData.properties[key];
				}
			}


			/*
			 this.alertData.properties['Affected Artifacts'] = this.alertData.impacted_files.length;
			 */

			this.alertData.properties = this.utils.getCapitalizedKeys(this.alertData.properties, {
				cve: 'CVE',
				cvss_v2: 'cvss_v2'
			})


			this.transformImpactedFiles();
		})
	}

	getLicenseIssueProperties(licenseIssue) {
		//console.log('getting license props', licenseIssue)
		this.alertData.properties = {};
		//unknow license modification

		this.alertData.properties.summary = licenseIssue.summary;
		this.alertData.properties.description = licenseIssue.description;


		this.alertData.properties.issue_type = licenseIssue.alert_type;

		this.alertData.properties.severity = licenseIssue.severity;
		this.alertData.properties.type = licenseIssue.type;

		if (this.affected_component && licenseIssue.components) {
			if (this.affected_component && licenseIssue.components.indexOf(this.affected_component.substr(
					this.affected_component.indexOf('://') + 3)) < 0 || licenseIssue.components.length > 1) {

				this.alertData.properties.affected_component = this.affected_component;
			}

		}

		if (licenseIssue.components) {

			this.alertData.properties[licenseIssue.components.length > 1 ? 'component_ids' : 'component_id'] = this.utils.semverSort(
				licenseIssue.components);
		}


		this.alertData.properties.created_date = this.alertData.created_at;


        this.alertData.properties = this.utils.getCapitalizedKeys(this.alertData.properties);


		this.transformImpactedFiles();

	}

	getScanIssues() {

		let impacted = this.impactedFilesOrig ? this.impactedFilesOrig : this.alertData.impacted_files;

		let issues = [];
		if (impacted) {
			impacted.forEach((impactedFile) => {
				let details = impactedFile.details;
				if (details) {
					details.forEach((detail) => {

						if (detail.vulnerabilities) {
							detail.vulnerabilities.forEach((vulnerability) => {
								if (!_.find(issues, {id: vulnerability.id})) {
									issues.push(vulnerability);
								}
							})
						}
						if (detail.banned_licenses) {
							detail.banned_licenses.forEach((licenseIssue) => {

								if (
									!_.find(issues, {summary: licenseIssue.summary})) {
									let issue = _.cloneDeep(licenseIssue);
									issue.licenseIssue = true;
									issue.components = [impactedFile.display_name];
									issues.push(issue);
								}

							})
						}
					})
					;
				}
			})
		}

		return issues;

	}

	ignoreCurrentIssue() {

		//need to swtich id to summary in case of license issue

		if (this.currentIssueIsLicense) {
			this.IgnoreModal.launchForIssue(_.find(this.issues, {summary: this.currentIssue}), this.alertData).then(
				(action) => {
					if (action === 'once') {
						this.ignore(false);
					}
					else if (action === 'permanently') {
						this.ignore(true);
					}
				});
		}
		else {
			this.IgnoreModal.launchForIssue(_.find(this.issues, {id: this.currentIssue}), this.alertData).then(
				(action) => {
					if (action === 'once') {
						this.ignore(false);
					}
					else if (action === 'permanently') {
						this.ignore(true);
					}
				});
		}

	}

	ignore(permanent) {
		let doAck = false;
		if (this.alertData.method === 'impactAnalysis' || (this.alertData.method === 'scan' && this.getScanIssues().length === 1)) {
			doAck = true;
		}

		if (!permanent && doAck) {
			this.alertsDao.acknowledge({}, {alert_ids: [this.alertData.id]}).$promise.then((response) => {
				this.back();
			});
		}
		else {
			let payload = {
				user_name: this.user.userName,
				watch_id: this.alertData.watch_id,
				alert_id: this.alertData.id
			};

			if (this.currentIssueIsLicense) {
				payload.licenses = [this.currentIssue];
			} else {
				payload.issues = [this.currentIssue];
			}

			this.IgnoreDao.addIgnore({ignore_once: !permanent}, payload).$promise.then((response) => {
				if (permanent && doAck) {
					this.alertsDao.acknowledge({}, {alert_ids: [this.alertData.id]}).$promise.then((response) => {
						this.back();
					});
				}
				else {
					this.currentIssue = null;
					this.getAlertData();
				}
			})
		}

	}


	back() {
		this.$state.go('alerts');
	}

	transformImpactedFiles() {

		if (!this.alertData.impacted_files || !Object.keys(
				this.alertData.impacted_files).length || this.impactedFilesTransformed) {
			return;
		}

		let impactedFilesOrig = this.impactedFilesOrig = this.alertData.impacted_files;

		this.alertData.impacted_files = [];

		if (this.alertData.method === 'impactAnalysis') {
			for (let key in impactedFilesOrig) {
				let file = impactedFilesOrig[key];
				if (file.sha256 === file.parent_sha) {
                    file.internalPath = file.path;//file.path.substr(file.path.indexOf('/')+1)
					this.alertData.impacted_files.push(file);
				}
			}
		}
		else { //Scan Alert
			this.scanImpactPaths = {};

			for (let key in impactedFilesOrig) {
				let details = impactedFilesOrig[key].details;
				if (details) {
					details.forEach((detail) => {
						let file = _.cloneDeep(detail.child);
						file.name = impactedFilesOrig[key].name;
						file.orig_display_name = file.display_name;
						file.display_name = impactedFilesOrig[key].display_name;
						file.path = impactedFilesOrig[key].path;
						file.orig_pkg_type = file.pkg_type;
						file.pkg_type = impactedFilesOrig[key].pkg_type;

						let issues = _.cloneDeep(detail.vulnerabilities);
						let licenseIssues = _.cloneDeep(detail.banned_licenses);
						if (issues) {
							issues.forEach((issue) => {
								if (!this.scanImpactPaths[issue.id]) {
									this.scanImpactPaths[issue.id] = [];
								}
								file.internalPath = file.path;//file.path.substr(file.path.indexOf('/')+1)
								this.scanImpactPaths[issue.id].push(file);
							})
						}
						if (licenseIssues) {
							licenseIssues.forEach((issue) => {
								if (!this.scanImpactPaths[issue.summary]) {
									this.scanImpactPaths[issue.summary] = [];
								}
								file.internalPath = file.path;//file.path.substr(file.path.indexOf('/')+1)
								this.scanImpactPaths[issue.summary].push(file);
							})
						}
					})
				}

			}
			if (this.currentIssue) {
				this.alertData.impacted_files = this.scanImpactPaths[this.currentIssue];
			}
		}

		if (this.alertData.impacted_files) {
			this.onClickAffectedFile(this.alertData.impacted_files[0]);
		}


		this.impactedFilesTransformed = true;
		//XRAY-748
		if (this.alertData.impacted_files) {
			this.alertData.impacted_files = _.sortBy(this.alertData.impacted_files, 'display_name');
		}
	}

	getImpactData(impactFile) {
		this.impactDao.get({}, {
			sha256: impactFile.sha256,
			alert_id: this.alertData.id,
			depth: impactFile.depth
		}).$promise.then((data) => {
			//            console.log('Impact Data:', data);
			let findFileBySha = (sha) => {
				let found = _.find(data, {sha256: sha});
				if (!found && impactFile.sha256 === sha) {
					return impactFile;
				} else {
					return found;
				}
			};
			let getChild = (file) => {
				return _.find(data, (f) => {
					return f.parent_sha === file.sha256 && f.sha256 !== file.sha256;
				});
			};
			let getParent = (file) => {
				return _.find(data, (f) => {
					return f.sha256 === file.parent_sha && f.sha256 !== file.sha256;
				});
			};


			let infectionPath = [];
			let curr = findFileBySha(impactFile.sha256);

			let sourceInPath = this.alertData.method === 'impactAnalysis' ? !!_.find(data, {depth: 0}) : false;
			while (curr) {
				//console.log('pushing', curr)
				infectionPath.push({
					name: curr.pkg_type === 'Docker' || curr.pkg_type === 'Build' ? curr.display_name : curr.display_name,
					icon: this.getPackageIcon(curr.pkg_type)
				});

				curr = this.alertData.method === 'impactAnalysis' ? getChild(curr) : getParent(curr);

			}

			if (!sourceInPath) {
				let sourceObj = {
					name: this.alertData.source_artifact,
					icon: this.getPackageIcon(this.alertData.source_pkg_type)
				};
				infectionPath.push(sourceObj);
				//                this.getComponentIcon(sourceObj);
			}

			if (this.alertData.method === 'scan') {
				var innerRev = infectionPath.slice(1, infectionPath.length - 1).reverse();
				innerRev.unshift(infectionPath[0]);
				innerRev.push(infectionPath[infectionPath.length - 1]);
				infectionPath = innerRev;
			}

			if (infectionPath.length) {
				if (!this.alertData.infection_paths) {
					this.alertData.infection_paths = {};
				}
				this.alertData.infection_paths[findFileBySha(impactFile.sha256).name] = infectionPath.reverse();
			}

		})

	}

	getPackageIcon(serverEnum) {
		let obj = _.find(PKG_TYPES, {serverEnumName: serverEnum});
		if (obj) {
			return obj.icon;
		}
	}

	onClickAffectedFile(affectedFile) {
		this.selectedAffectedFile = affectedFile;
		//        if (!this.alertData.infection_paths || !this.alertData.infection_paths[affectedFile.name]) {

		if (this.alertData.method === 'scan') {
			this.alertData.source_artifact = affectedFile.orig_display_name || affectedFile.display_name;
			this.alertData.source_pkg_type = affectedFile.orig_pkg_type;
			this.alertData.source_compId = affectedFile.orig_display_name || affectedFile.display_name;
		}
		else if (affectedFile.details) {
			this.alertData.source_artifact = affectedFile.details[0].child.display_name || affectedFile.orig_display_name || affectedFile.display_name;
			this.alertData.source_pkg_type = affectedFile.details[0].child.pkg_type;
			this.alertData.source_compId = affectedFile.details[0].child.display_name;
		}
		this.getImpactData(affectedFile);

		//        }
	}

	_getColumns() {
		return [
			{
				name: 'Component',
				displayName: 'Component',
                field: 'artifact',
				width: '15%',
				allowGrouping: true
			},
			{
				name: 'Inner Path',
				displayName: 'Inner Path',
                field: 'path',
				width: '20%'
			},
			{
				name: 'Severity',
				displayName: 'Severity',
                field: 'severity',
				cellTemplate: '<div class="ui-grid-cell-contents severity"><div class="severity-colorbar" ng-class="(row.entity.severity).toLowerCase()"></div>{{row.entity.severity}}</div>',
				width: '10%',
				allowGrouping: true
			},
			{
				name: 'Type',
				displayName: 'Type',
                field: 'type',
				width: '10%',
				allowGrouping: true
			},
			{
				name: 'Summary',
				displayName: 'Summary',
                field: 'summary',
				width: '20%'
			},
			{
				name: 'Description',
				displayName: 'Description',
                field: 'description',
				width: '25%'
			}
		]
	}


	//*****************************************************


	capitalWord(val) {

		if (val.charAt(0).toUpperCase() == val.charAt(0)) {
			return val.charAt(0).toUpperCase() + val.slice(1);
		}

		return val;
	}

	updateIssueTabs() {

		let tabs = [];
		this.issueTabsDictionary = {};
		let tabWidthPercent = Math.floor(90 / this.issues.length);
		if (tabWidthPercent > 40) {
			tabWidthPercent = 40;
		}
		if (tabWidthPercent < 6) {
			tabWidthPercent = 6;
		}
		this.tabWidth = tabWidthPercent + '%';

		this.issues.forEach((issue) => {

			let customClass = '';

			if (issue.severity) {
				customClass = issue.severity.toLowerCase();
			}
			//unknown license modification
			if (issue.licenseIssue) {
				//console.log('This is License Issue!!', issue);
                if (issue.summary.toLowerCase().trim() === 'unknown') {

					tabs.push({name: issue.summary, fullObject: issue, class: customClass});
					this.issueTabsDictionary[issue.summary] = issue.description || 'ISSUE #' + (this.issues.indexOf(
                        issue) + 1);
				}
				else {

					tabs.push({name: issue.summary, fullObject: issue, class: customClass});
					this.issueTabsDictionary[issue.summary] = issue.summary || 'ISSUE #' + (this.issues.indexOf(
                        issue) + 1);
				}

			}
			else {
				tabs.push({name: issue.id, fullObject: issue, class: customClass});
				this.issueTabsDictionary[issue.id] = issue.summary || 'ISSUE #' + (this.issues.indexOf(issue) + 1);
			}

		});

		this.issueTabs = undefined;
		this.$timeout(() => {
			this.issueTabs = _.sortBy(tabs, 'class');
			this.$timeout(() => {
				this.fix_size();
			})
		})
	}

	onChangeIssue(tab) {

		this.currentIssue = tab.name;
		this.currentIssueIsLicense = !!tab.fullObject.licenseIssue;
		if (this.alertData.method === 'scan' && this.impactedFilesTransformed) {
			this.alertData.impacted_files = this.scanImpactPaths[this.currentIssue];
			this.$timeout(() => {
				this.onClickAffectedFile(this.alertData.impacted_files[0]);
			})
		}
		if (!tab.fullObject.licenseIssue && tab.name !== '') {
			this.getEventXData(tab.name);
		}
		else {
			this.getLicenseIssueProperties(tab.fullObject);
		}

	}


	getComponentIcon(compObj) {
		this.componentsDao.getData({}, {
			component_id: this.alertData.source_compId
		}).$promise.then((data) => {
			compObj.icon = this.getPackageIcon(data.pkg_type || 'Generic');
		})
	}

	getImpactPathCaption() {

		if (!this.selectedAffectedFile || !this.selectedAffectedFile.internalPath) {
			return '';
		}
		return '<span class="bold-title">Impact Path: </span>' + '<span>' + this.selectedAffectedFile.internalPath + '</span>';
	}

	isArray(o) {
		return _.isArray(o);
	}

	isLink(str) {

		if (typeof str != 'string' || !str) {
			return false;
		}

		return str && str.startsWith('http://') || str.startsWith('https://') || str.startsWith('www.');
	}
}



// WEBPACK FOOTER //
// ./modules/xray/states/alerts/alert_details.controller.js